var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: ["information-container"],
      on: { mouseenter: _vm.hover, mouseleave: _vm.hoverOut }
    },
    [
      _c("img", {
        class: [{ light: _vm.iconTheme === "light" }],
        attrs: { src: require("@/drc/assets/icons/information.svg"), alt: "i" }
      }),
      _vm.isOpened
        ? _c(
            "div",
            { staticClass: "information-tooltip" },
            [_vm._t("default")],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }